// libraries.
import { Dropdown, Form } from 'react-bootstrap';

// icons.
import { IconFilter } from '@assets/icons';

// styles.
import { WrapperInputField } from './styles';

interface DropdownFilterProps {
  options: { value: string; label: string }[];
  onChange?: (selected: string[]) => void;
  value?: string[];
}

export const DropdownFilter = ({
  options,
  onChange,
  value = [],
}: DropdownFilterProps) => {
  const allOptionValues = options.map(option => option.value);

  const selected = value;

  const handleSelect = (optionValue: string) => {
    let newSelected: string[];

    if (optionValue === 'ALL') {
      newSelected =
        selected.length === allOptionValues.length ? [] : allOptionValues;
    } else {
      newSelected = selected.includes(optionValue)
        ? selected.filter(item => item !== optionValue)
        : [...selected, optionValue];
    }

    onChange?.(newSelected);
  };

  const isAllSelected = selected.length === allOptionValues.length;

  return (
    <WrapperInputField>
      <Dropdown>
        <Dropdown.Toggle className="w-100 multi-dropdown">
          <IconFilter />
        </Dropdown.Toggle>
        <Dropdown.Menu className="wrapper-items" flip={true}>
          <Dropdown.Item as="div" onClick={e => e.stopPropagation()}>
            <Form.Check
              type="checkbox"
              id="checkbox-all"
              label="Todos"
              checked={isAllSelected}
              onChange={() => handleSelect('ALL')}
            />
          </Dropdown.Item>

          {options.map(option => (
            <Dropdown.Item
              key={option.value}
              as="div"
              onClick={e => e.stopPropagation()}
            >
              <Form.Check
                type="checkbox"
                id={`checkbox-${option.value}`}
                label={option.label}
                checked={selected.includes(option.value)}
                onChange={() => handleSelect(option.value)}
              />
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </WrapperInputField>
  );
};
